module.exports = __webpack_public_path__ + "static/media/dmiLogo2.23a8aeb1.svg";